import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import 'react';
import { themed } from '@indeed/ifl-css';
import { keyframes, jsx } from '@emotion/react';
import useResponsiveValue from '../../hooks/useResponsiveValue.js';
import { Flex } from '../Flex/Flex.js';
import '../../hooks/useBreakpointIndex.js';

const sizeVariants = {
  md: {
    blockSize: "3.438rem"
  },
  sm: {
    blockSize: "1.875rem"
  }
};
const alignmentStyles = {
  left: {
    alignSelf: "flex-start"
  },
  right: {
    alignSelf: "flex-end"
  },
  center: {
    alignSelf: "center"
  },
  justify: {
    alignSelf: "flex-start"
  }
};
const skeletonVariants = (size, align, width) => ({
  heading: {
    ...sizeVariants[size],
    ...alignmentStyles[align]
  },
  text: {
    ...alignmentStyles[align],
    inlineSize: `${width}`
  },
  circle: {
    borderRadius: "50%",
    flex: 1,
    blockSize: "6.25rem",
    inlineSize: "6.25rem"
  },
  square: {
    blockSize: "6.25rem",
    inlineSize: "6.25rem"
  }
});
const animationSpeeds = {
  snappy: "0.5s",
  quick: "1s",
  normal: "1.5s",
  slow: "2s",
  slowest: "2.5s"
};
const defaultWidths = [97, 100, 94, 90, 98, 95, 98, 40];
const skeletonKeyframes = width => keyframes`
  0% { transform: translate(-${width}); }
  60% { transform: translate(${width}); }
  100% { transform: translate(${width}); }
`;
const baseStyles = () => ({
  position: "relative",
  bg: "background.strong",
  lineHeight: "1",
  overflow: "hidden",
  transform: "translate3d(0,0,0)",
  backfaceVisibility: "hidden",
  borderRadius: "sm",
  display: "block",
  inlineSize: "100%"
});
const propStyles = _ref => {
  let {
    align,
    size,
    speed,
    variant,
    width = "100%"
  } = _ref;
  return {
    // @ts-ignore
    ...skeletonVariants(size, align, width)[variant],
    "&::after": {
      content: "' '",
      position: "absolute",
      bottom: 0,
      right: 0,
      left: 0,
      top: 0,
      backgroundImage: "skeleton.gradient",
      animation: `${skeletonKeyframes(width)} ${speed} linear infinite`,
      "@media (prefers-reduced-motion: reduce)": {
        animationDuration: "8s"
      }
    }
  };
};
const rejectedSkeletonAttribute = new Set(["align", "size", "speed", "variant", "width"]);
const StyledSkeleton = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: ["align", "size", "speed", "variant", "width"],
  shouldForwardProp: prop => !rejectedSkeletonAttribute.has(prop),
  target: "eibgs5u0"
} : {
  styleProps: ["align", "size", "speed", "variant", "width"],
  shouldForwardProp: prop => !rejectedSkeletonAttribute.has(prop),
  target: "eibgs5u0",
  label: "StyledSkeleton"
})(baseStyles, propStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const getTextWidth = (align, i) => {
  return align === "justify" ? "100%" : `${defaultWidths[(i + defaultWidths.length) % defaultWidths.length]}%`;
};
const Paragraph = _ref2 => {
  let {
    align,
    count,
    speed,
    ...props
  } = _ref2;
  const lines = Array(count).fill(null);
  return jsx(Flex, {
    sx: {
      flexDirection: "column",
      flex: "1",
      minInlineSize: 100,
      "& *:not(:last-child)": {
        marginBlockEnd: 4
      }
    }
  }, lines.map((_, i) => jsx(StyledSkeleton, _extends({
    key: i,
    align: align,
    speed: speed,
    size: "md",
    width: getTextWidth(align, i),
    variant: "text"
  }, props), "\u00A0")));
};

/**
 * @see https://experience.indeed.design/components/ids/skeleton
 */
const Skeleton = _ref3 => {
  let {
    align = "left",
    count = 1,
    size = "md",
    speed = "normal",
    variant = "text",
    ...props
  } = _ref3;
  const alignment = useResponsiveValue(align);
  const lineCount = useResponsiveValue(count);
  const animationSpeed = useResponsiveValue(speed);
  const lineHeight = useResponsiveValue(size);
  const finalSpeed = SKELETON_ANIMATION_SPEEDS.indexOf(animationSpeed) >= 0 ?
  // @ts-ignore
  animationSpeeds[animationSpeed] : animationSpeed;
  return variant === "text" ? jsx(Paragraph, _extends({
    align: alignment,
    count: lineCount,
    speed: finalSpeed
  }, props)) : jsx(StyledSkeleton, _extends({
    align: alignment,
    size: lineHeight,
    speed: finalSpeed,
    variant: variant
  }, props), "\u00A0");
};
const SKELETON_ALIGNMENT = Object.keys(alignmentStyles);
const SKELETON_ANIMATION_SPEEDS = ["snappy", "quick", "normal", "slow", "slowest"];
const SKELETON_SIZE = Object.keys(sizeVariants);
const SKELETON_VARIANTS = ["circle", "heading", "square", "text"];
Skeleton.displayName = "Skeleton";

export { SKELETON_ALIGNMENT, SKELETON_ANIMATION_SPEEDS, SKELETON_SIZE, SKELETON_VARIANTS, Skeleton, StyledSkeleton, skeletonKeyframes, skeletonVariants };
